import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function MentionsLegales() {
  return (
    <div>
      <div className="bg-[#EFEBE5] px-6 md:px-12 lg:px-24 py-3">
        <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm font-body text-[#6B6B6B]">
          <Link to="/" className="hover:text-[#2D5016]">Accueil</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#2D5016] font-medium">Mentions legales</span>
        </div>
      </div>

      <section className="py-16 md:py-24 px-6 md:px-12 lg:px-24" data-testid="mentions-legales-page">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl font-bold text-[#2C2C2C] mb-12">Mentions legales</h1>

          <div className="space-y-8 font-body text-[#2C2C2C]/80 leading-relaxed">
            <div>
              <h2 className="font-heading text-2xl font-semibold text-[#2C2C2C] mb-3">Editeur du site</h2>
              <p>VisitMonde — La Boussole Ethnique</p>
              <p>6, place de la Fontaine — 78670 Villennes sur Seine</p>
              <p>RCS : 811 258 046</p>
              <p>Immatriculation Atout France : IM 078 150006</p>
              <p>Responsabilite Civile Professionnelle : Allianz, contrat n 555 04 182</p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-semibold text-[#2C2C2C] mb-3">Directeur de la publication</h2>
              <p>M. Marc DOMINICI</p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-semibold text-[#2C2C2C] mb-3">Hebergeur</h2>
              <p>Emergent</p>
              <p>Site web : <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#2D5016] underline">emergent.sh</a></p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-semibold text-[#2C2C2C] mb-3">Contact</h2>
              <p>Email : <a href="mailto:dominicimarc64@gmail.com" className="text-[#2D5016] underline">contact@visitmonde.com</a></p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-semibold text-[#2C2C2C] mb-3">Propriete intellectuelle</h2>
              <p>L'ensemble du contenu de ce site (textes, images, videos, logos) est la propriete exclusive de VisitMonde ou de ses partenaires. Toute reproduction, meme partielle, est interdite sans autorisation ecrite prealable.</p>
            </div>

            <div>
              <h2 className="font-heading text-2xl font-semibold text-[#2C2C2C] mb-3">Donnees personnelles</h2>
              <p>Conformement a la loi Informatique et Libertes et au RGPD, vous disposez de droits sur vos donnees personnelles. Consultez notre <Link to="/politique-de-confidentialite" className="text-[#2D5016] underline">politique de confidentialite</Link> pour en savoir plus.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
